module.exports = __webpack_public_path__ + "static/media/de_ancient.788f7466.jpg";